// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-product-container {
  height: auto;
  margin-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/storyblok/components/storyblok-product-list/storyblok-product-list.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,mBAAA;AACF","sourcesContent":["app-product-container {\n  height: auto;\n  margin-bottom: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
